// extracted by mini-css-extract-plugin
export default {"grid":"ArticleList_grid__rfQGF","card":"ArticleList_card__JhRAZ","title":"ArticleList_title__3pjW0","meta":"ArticleList_meta__LSqmH"};